import React, { FC, useContext, useEffect, useState } from 'react';

import { Chip, CircularProgress, FormControl, FormLabel } from '@material-ui/core';
import { ValueType } from 'react-select/lib/types';

import { GlobalContext } from '../../../../../../../store';
import { IRoundGame } from '../../../../../../../store/admin/eventRounds/store';

import { PlayerMetaDataSectionStyled } from './PlayerMetaDataSection.Styles';
import AutoComplete from '../../../../../../../components/AutoComplete';
import { getAutoCompleteOptionsArray } from '../../../../../../../contrib/Utils/getAutoCompleteOptionsArray';
import { IOption } from '../../../../../../../components/Select/Select';
import { useRouteInfoState } from '../../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { sortBy } from '../../../../../../../contrib/sortBy';

interface IProps {
  game: IRoundGame | undefined;
}

const Flight: FC<IProps> = props => {
  const { game } = props;

  const {
    actions: {
      adminEventEnrollments: { edit: editEnrollments },
      adminEventRounds: { get: getAdminEventRound }
    },
    adminEvents: { current: currentEvent },
    playerEditorModal: { enrollment }
  } = useContext(GlobalContext);

  const { clubId, eventId, roundId } = useRouteInfoState();

  const [options, setOptions] = useState<IOption[]>([]);

  const [value, setValue] = useState<IOption>();

  const [sectionState, setSectionState] = useState<'idle' | 'loading' | 'saved'>('idle');

  useEffect(() => {
    if (enrollment) {
      setValue(options.find(c => enrollment.flight && c.value === String(enrollment.flight.id)));
    }
  }, [enrollment, options]);

  useEffect(() => {
    if (currentEvent && currentEvent.flights.length > 0) {
      const eventFlights = currentEvent.flights.filter(flight => flight.category === 'i');
      setOptions(getAutoCompleteOptionsArray(sortBy(eventFlights, 'asc', 'id')));
    }
  }, [currentEvent]);

  if (!currentEvent || !enrollment) {
    return <></>;
  }

  const onChange: (value: ValueType<IOption>) => Promise<void> = async selectedFlight => {
    const flight = currentEvent.flights.find(
      eventFlight => String(eventFlight.id) === (selectedFlight as IOption).value
    );

    if (game && clubId && eventId && enrollment) {
      const { id } = enrollment;

      setSectionState('loading');

      const response = await editEnrollments(clubId, eventId, [{ id, flight }]);
      await getAdminEventRound(Number(clubId), Number(eventId), Number(roundId), true);

      if (response.errors) {
        // manage errors somehow
        setSectionState('idle');
      } else {
        setValue(options.find(c => c.value === (selectedFlight as IOption).value));

        setSectionState('saved');

        setTimeout(() => setSectionState('idle'), 3 * 1000);
      }
    }
  };

  const stateIndicators = {
    idle: <></>,
    loading: <CircularProgress className="loader" size={15} />,
    saved: <Chip size="small" label="Saved" color="primary" variant="outlined" />
  };

  return (
    <PlayerMetaDataSectionStyled>
      <FormControl classes={{ root: 'formcontrol-container' }} component="fieldset">
        <FormLabel component="legend">
          <p>FLIGHT:</p>

          {stateIndicators[sectionState]}
        </FormLabel>

        <AutoComplete value={value} onChange={onChange} options={options} isDisabled={!game} />
      </FormControl>
    </PlayerMetaDataSectionStyled>
  );
};

export default Flight;
